import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.css'

// Un nouveau déploiement change le hash des chunks JS (code-splitting par route).
// Si un visiteur (ou Googlebot) a la page ouverte pendant qu'un déploiement passe,
// le lazy-loading d'une route peut pointer vers un chunk qui n'existe plus →
// "Failed to fetch dynamically imported module". Vite émet cet événement dans ce
// cas précis ; on recharge simplement la page pour récupérer les bons chunks.
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

// En production avec prerendering : hydrate (réutilise le HTML pré-rendu)
// En développement : createRoot classique
const rootElement = document.getElementById('root')!
const isPrerendered = rootElement.hasAttribute('data-prerendered')

if (isPrerendered) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}
